<div [ngClass]="{'controller-container': isController}" class="container" >
  <div style="display: flex;flex-direction: row;justify-content: space-between; width: 100%;">
    <button *ngIf="isController" mat-fab extended class="title-btn"   [routerLink]="['/ring-functions']"><mat-icon>arrow_back</mat-icon>Back</button>
    <div class="title"><span>Scheduled Rings</span></div>
    <button mat-fab extended class="title-btn"  (click)="addNewSchedule()"><mat-icon>add</mat-icon>Add new</button>
  </div>

  <table mat-table [dataSource]="scheduledRings" class="mat-elevation-z8">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let schedule">
        <ng-container *ngIf="schedule.isFirstEdit">
          <mat-form-field style="width:70px">
            <mat-label>ID</mat-label>
            <input  matInput [(ngModel)]="schedule.id">
          </mat-form-field>
        </ng-container>
        <span *ngIf="!schedule.isFirstEdit" [ngClass]="{'disabled-row': schedule.disabled}">
          {{schedule.id}}
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="occurs">
      <th mat-header-cell *matHeaderCellDef>Days</th>
      <td mat-cell *matCellDef="let schedule">
        <ng-container *ngIf="schedule.isEditing">
          <mat-form-field style="width:150px">
            <mat-label>Occurs On</mat-label>
            <mat-select [(ngModel)]="schedule.occurs">
              <mat-option [value]="OccurenceTypes.DAILY" >Every Day</mat-option>
              <mat-option [value]="OccurenceTypes.SELECTED_DAYS">Selected Days</mat-option>
            </mat-select>
          </mat-form-field>
          <ng-container *ngIf="schedule.occurs == OccurenceTypes.SELECTED_DAYS">
              <mat-form-field style="width:150px">
                <mat-label>Select days</mat-label>
                <mat-select [(ngModel)]="schedule.days" multiple>
                    <mat-option *ngFor="let item of [].constructor(7);  let idx = index" [value]="idx">{{Day[idx]}}</mat-option>
                </mat-select>
              </mat-form-field>
          </ng-container>
        </ng-container>
        <span *ngIf="!schedule.isEditing" [ngClass]="{'disabled-row': schedule.disabled}">
          <div *ngIf="schedule.occurs == OccurenceTypes.SELECTED_DAYS" style="display: flex;flex-direction: column;">
            <div *ngFor="let day of schedule.days"> {{ Day[day] }}</div>
          </div>
          <div *ngIf="schedule.occurs == OccurenceTypes.DAILY">Every Day</div>
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="time">
      <th mat-header-cell *matHeaderCellDef>Time</th>
      <td mat-cell *matCellDef="let schedule" [ngClass]="{'time-container':schedule.isEditing}">
        <ng-container *ngIf="schedule.isEditing">
          <mat-form-field style="width:110px">
            <mat-label>Time</mat-label>
            <input
            type="text"
            placeholder="HH:MM"
            matInput
            [ngxMatTimepicker]="timepicker"
            [format]="24"
            readonly
            [(ngModel)]="schedule.time"
          />

          <!-- <mat-icon
            matPrefix
            (click)="schedule.time=null"
          >
            close
          </mat-icon> -->

          <mat-icon
            matSuffix
            (click)="openFromIcon(timepicker)"
            >schedule</mat-icon
          >
        </mat-form-field>
          <!-- <mat-form-field class="time-field">
            <mat-label>MM</mat-label>
            <mat-select [(ngModel)]="schedule.mm">
              <mat-option *ngFor="let item of [].constructor(60);  let idx = index" [value]="idx">{{idx}}</mat-option>
            </mat-select>
          </mat-form-field> -->
          <ngx-mat-timepicker #timepicker [format]="24"></ngx-mat-timepicker>
        </ng-container>
        <span *ngIf="!schedule.isEditing" [ngClass]="{'disabled-row': schedule.disabled}">
          <span>{{ schedule.time|timeFormat }}</span>
        </span>
        </td>
    </ng-container>
    <ng-container matColumnDef="ringPattern">
      <th mat-header-cell *matHeaderCellDef>Pattern To Ring</th>
      <td mat-cell *matCellDef="let schedule">
        <ng-container *ngIf="schedule.isEditing">
          <mat-form-field >
            <mat-label>Ring Pattern</mat-label>
            <mat-select [(ngModel)]="schedule.pattern">
              <mat-option *ngFor="let pattern of ringPatternArr" [value]="pattern.id">{{ pattern.id +' - '+pattern.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
        <span *ngIf="!schedule.isEditing" [ngClass]="{'disabled-row': schedule.disabled}">
          <span>{{ (ringPatterns && ringPatterns[schedule.pattern])? ringPatterns[schedule.pattern].name :'Pattern Not Found'}}</span>
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Delete/Edit/Disable</th>
      <td mat-cell *matCellDef="let schedule">
        <ng-container *ngIf="schedule.isEditing">
          <button mat-mini-fab class="action-btn" (click)="updateScheduledRing(schedule)">Save</button>
          <button mat-mini-fab class="action-btn" (click)="cancelEditing(schedule)">Back</button>
        </ng-container>
        <ng-container *ngIf="!schedule.isEditing">
          <button mat-mini-fab [disabled]="schedule.disabled" class="action-btn danger" (click)="deleteSchedule(schedule)"><mat-icon>delete_forever</mat-icon></button>
          <button mat-mini-fab [disabled]="schedule.disabled" class="action-btn" (click)="startEditing(schedule)"><mat-icon>edit</mat-icon></button>
          <mat-slide-toggle [checked]="schedule.disabled" (change)="onDisableChange(schedule,$event)">{{schedule.disabled?"Disabled":''}}</mat-slide-toggle>
        </ng-container>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="scheduledTblColumns"></tr>
    <tr mat-row *matRowDef="let row;columns:scheduledTblColumns;"></tr>
  </table>
</div>
